const ListView = require("../../clover/panel/component/common/ListView");
const WelfareCenterBannerItem = require("./WelfareCenterBannerItem");
const WelfareCenterLogic = require("./WelfareCenterLogic");

let WelfareCenterPanel = xClass("WelfareCenterPanel", BasePanel, function () {
    return cc.CSLoader.createNode("cocos/welfare_welfare.csb");
})
const RES = ["packed/WelfareCenter.pack","font/zzgftongxin_40.fnt"];
let [ContainerWidth, ContainerHeight] = [720, 987];
let ContainerPos = [-360, -597];
//背景图顶部超出像素
const topInterval = 60;

WelfareCenterPanel.preloadRes = function (onSuccess, onFail, onCancel, useMask = false) {
    preloadWithLoading(RES, onSuccess, onFail, onCancel, useMask)
}

WelfareCenterPanel.prototype.ctor = function () {
    let self = this;
    BasePanel.prototype.ctor.call(self);

    self.fitScreen();
    self.initUI();
}

WelfareCenterPanel.prototype.initUI = function () {
    let self = this;
    self.curTab = 0;
    self.nodepool = [];

    self.com_close = self.getChildByName("com_back");
    self.scrollViewNode = self.getChildByName("scrollViewBg");

    for (let i = 1; i < 3; i++) {
        const tab = self.getChildByName(`tab${i}`);
        if (tab) {
            tab.setLocalZOrder(99 + i);
            tab.setAnchorPoint(0, -0.5);
            tab.y -= tab.height / 2;
            quickBuildUIButton(tab, function () {
                const plt = i == 1 ? "pay" : "free";
                const type = WelfareCenterLogic.dcInfo.type || "pay";
                const pf = WelfareCenterLogic.dcInfo.pf || "page";
                WelfareCenterLogic.dcSimple("page_click", { pf, plt, type });
                //
                self.changeTab(i);
            });
        }
    }

    self.com_close.setLocalZOrder(102);
    quickBuildUIButton(self.com_close, function () {
        const plt = "close";
        const type = WelfareCenterLogic.dcInfo.type || "pay";
        const pf = WelfareCenterLogic.dcInfo.pf || "page";
        WelfareCenterLogic.dcSimple("page_click", { pf, plt, type });

        self.onClose();
    });

    //创建列表
    let scrollView = ListView.create(this);
    scrollView.setBounceEnabled(true);
    scrollView.setContentSize(ContainerWidth, ContainerHeight);
    scrollView.y = ContainerPos[1];
    scrollView.x = ContainerPos[0];
    self.addChild(scrollView);

    self.listView = scrollView;
    self.listView.setSwallowTouches(true);
    //屏蔽banner点击穿透
    let darkLayer = cc.LayerColor.create(new cc.Color(155, 0, 0, 0));
    darkLayer.setContentSize(ContainerWidth, 310)
    darkLayer.setPosition(ContainerPos[0], scrollView.y + ContainerHeight);
    UIButton.create(darkLayer);
    darkLayer.setSwallowTouches(true)
    self.addChild(darkLayer);
    //
    self.changeTab(2);
    self.refreshTab();

    let pos = self.getChildByName("tab2").getPosition()
    self.getChildByName("tab2").setPosition(self.getChildByName("tab1").getPosition())
    self.getChildByName("tab1").setPosition(pos)
}

//外部通知删除、添加item时
WelfareCenterPanel.prototype.onChangeItem = function (data) {
    let self = this;
    let cfg = WelfareCenterLogic.config[data.id];
    if (cfg && cfg.type == self.curTab && cfg.show) {
        self.showList(self.curTab);
        console.log("福利中心 刷新banner列表");
    }
    //
    self.refreshTab();
}

//切换 超值好礼 - 1  免费福利 - 2
WelfareCenterPanel.prototype.changeTab = function (showTab) {
    let self = this;
    for (let i = 1; i < 3; i++) {
        const tab = self.getChildByName(`tab${i}`);
        if (tab) {
            const show = showTab == i;
            tab.getChildByName("welfare_tab_selected").setVisible(show);
        }
    }
    //
    if (self.curTab != showTab) {
        self.showList(showTab);
        //
        let plt = "";
        //最后一个是敬请期待
        for (let i = 0; i < this.listData.length - 1; i++) {
            let name = WelfareCenterLogic.activityName[this.listData[i].id];
            if (name) {
                plt += name;

                if (i != this.listData.length - 1) {
                    plt += ";";
                }
            }
        }

        const type = showTab == 1 ? "pay" : "free";
        let pf = "page";
        if (!self.curTab) {
            //初始化时
            pf = "icon";
            if (WelfareCenterLogic.enterType){
                pf = WelfareCenterLogic.enterType
            }
        }
        let params = WelfareCenterLogic.dcSimple("page_show", { pf, plt, type });
        if (params.session) {
            WelfareCenterLogic.dcInfo = {
                session: params.session,
                pf,
                type,
            };
        }
        self.curTab = showTab;
    }
}

//刷新tab上的红点 “！”
WelfareCenterPanel.prototype.refreshTab = function () {
    let self = this;
    for (let i = 1; i < 3; i++) {
        const tab = self.getChildByName(`tab${i}`);
        if (tab) {
            let newNode = tab.getChildByName("new");
            let dot = tab.getChildByName("dot");
            let arr = WelfareCenterLogic.getActivityByType(i);
            let isNew = false;
            let isDot = false;
            for (let j = 0; j < arr.length; j++) {
                if (WelfareCenterLogic.showActivityIds.indexOf(arr[j].id) == -1) {
                    isNew = true;
                    break;
                }
                if (!!arr[j].redDot) {
                    isDot = true;
                }
            }

            if (isNew) {
                newNode && newNode.setVisible(true);
                dot && dot.setVisible(false);
            } else {
                newNode && newNode.setVisible(false);
                dot && dot.setVisible(isDot);
            }
        }
    }
}

//创建列表项
WelfareCenterPanel.prototype.getItem = function () {
    let self = this;
    let item = null;
    if (self.nodepool.length) {
        item = self.nodepool.shift();
    } else {
        item = WelfareCenterBannerItem.create();
    }
    return item;
}

WelfareCenterPanel.prototype.showList = function (showTab) {
    this.listData = []//模拟数据
    let arr = WelfareCenterLogic.getActivityByType(showTab);
    arr.push({
        id: WelfareCenterId.unknown,
        redDot: false,
        countDown: 0,
    })
    this.listData = arr;
    this.listView.setVisible(true)
    this.listView.refresh(0);
}

WelfareCenterPanel.prototype.delegate_getLength = function () {
    let self = this;
    return self.listData ? self.listData.length : 0;
}

WelfareCenterPanel.prototype.delegate_getItemHeight = function (index) {
    return 226;
}

WelfareCenterPanel.prototype.delegate_renderItem = function (index, itemView) {
    let self = this;
    if (itemView == null) {
        itemView = self.getItem();
    }
    let itemData = self.listData && self.listData[index];
    if (itemData) {
        itemView.initData(itemData);
    }
    return itemView;
}

WelfareCenterPanel.prototype.onClose = function (callback, arg, withoutAnim) {
    let self = this;
    //
    BasePanel.prototype.onClose.call(self, callback, arg, 1);
}

WelfareCenterPanel.prototype.onCleanup = function () {
    let self = this;
    WelfareCenterLogic.enterType = null
    ResManager.release(RES);
}

WelfareCenterPanel.prototype.fitScreen = function () {
    let self = this;

    const bgSpr = self.getChildByName("welfare_bg1");
    const scaleY = display.height / GamePlayConfig_Design_Height;
    const scaleX = display.width / GamePlayConfig_Design_Width;

    if (scaleY / scaleX > 1) {
        //偏长屏
        bgSpr.height = display.height;//底部需要截掉的像素加上即可

        let moveY = (display.height - GamePlayConfig_Design_Height) / 2 - topInterval;
        const arr = self.getChildren();
        for (let i = 0; i < arr.length; i++) {
            arr[i].y += moveY;
        }
        //
        ContainerHeight = bgSpr.height - 310 - 43;
        ContainerPos = [-ContainerWidth / 2, -display.height / 2 + 43];
    } else {
        let scale = Math.min(scaleX, scaleY);
        self._scale = scale;
        self.setScale(self._scale);

        bgSpr.height = display.height / scale + topInterval;
        //
        // let moveY = (display.height - GamePlayConfig_Design_Height) / 2;
        // const arr = self.getChildren();
        // for (let i = 0; i < arr.length; i++) {
        //     arr[i].y += moveY;
        // }

        // ContainerHeight = bgSpr.height - 310 - topInterval - 43;
        // ContainerPos = [-ContainerWidth / 2, -display.height / 2 + 43];
    }
}

module.exports = WelfareCenterPanel;